module.exports = __webpack_public_path__ + "static/media/uppercut.2ad087be.png";